var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DrawerMenuItem = void 0; // eslint-disable-next-line no-use-before-define

var React = __importStar(require("react"));

var core_1 = require("@material-ui/core");

var ListSubheader_1 = __importDefault(require("../../ListSubheader"));

var Typography_1 = __importDefault(require("../../Typography"));

var ListItem_1 = __importDefault(require("../../ListItem"));

var ListItemIcon_1 = __importDefault(require("../../ListItemIcon"));

var Icon_1 = __importDefault(require("../../Icon"));

var ListItemText_1 = __importDefault(require("../../ListItemText"));

var MenuItemText_1 = require("../MenuItemText");

exports.DrawerMenuItem = React.forwardRef(function (props, ref) {
  var onSelect = props.onSelect,
      name = props.name,
      icon = props.icon,
      selected = props.selected,
      section = props.section;
  var useListItemStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d;

    return {
      root: {
        borderRadius: (_a = theme.shape) === null || _a === void 0 ? void 0 : _a.borderRadius,
        cursor: "pointer",
        padding: (_b = theme.sizes) === null || _b === void 0 ? void 0 : _b.tiny,
        // eslint-disable-next-line sort-keys
        "&:hover": {
          backgroundColor: (_d = (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.action) === null || _d === void 0 ? void 0 : _d.hover
        }
      }
    };
  });
  var classes = useListItemStyles();
  var useListItemIconStyles = core_1.makeStyles(function (_a) {
    var sizes = _a.sizes;
    return core_1.makeStyles({
      root: {
        marginRight: sizes === null || sizes === void 0 ? void 0 : sizes.standard,
        marginTop: sizes === null || sizes === void 0 ? void 0 : sizes.none,
        minWidth: "auto"
      }
    });
  });
  var classesIcon = useListItemIconStyles();
  var useListSubheaderStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f;

    return core_1.makeStyles({
      root: {
        backgroundColor: "" + ((_b = (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.background) === null || _b === void 0 ? void 0 : _b.paper),
        borderTop: ((_d = (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.action) === null || _d === void 0 ? void 0 : _d.hover) + " 1px solid",
        margin: ((_e = theme.sizes) === null || _e === void 0 ? void 0 : _e.small) + "px -" + ((_f = theme.sizes) === null || _f === void 0 ? void 0 : _f.tiny) + "px 0"
      }
    });
  });
  var classesSubheader = useListSubheaderStyles();

  if (section) {
    return React.createElement(ListSubheader_1.default, {
      classes: classesSubheader
    }, React.createElement(Typography_1.default, {
      variant: "caption",
      component: "span"
    }, section));
  }

  var handleClick = function handleClick(event) {
    return onSelect && onSelect(event, name);
  };

  var onClick = onSelect ? {
    onClick: handleClick
  } : {};
  return React.createElement(ListItem_1.default, __assign({}, onClick, {
    classes: classes,
    selected: selected,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    component: "li",
    button: true,
    ref: ref
  }), icon && React.createElement(ListItemIcon_1.default, {
    classes: classesIcon
  }, React.createElement(Icon_1.default, {
    name: icon,
    size: "tiny"
  })), React.createElement(ListItemText_1.default, null, React.createElement(MenuItemText_1.MenuItemText, __assign({}, props))));
});
exports.DrawerMenuItem.displayName = "DrawerMenuItem";
exports.default = exports.DrawerMenuItem;